const T = 3e6, E = {
  circle: "d-bar-circle",
  square: "d-bar2"
}, s = [
  "body",
  "heading"
], _ = {
  sm: "24px",
  md: "32px",
  lg: "48px"
}, S = {
  sm: "d-h16",
  md: "d-h24",
  lg: "d-h32"
}, c = {
  SKELETON_RIPPLE_DURATION: 3e6,
  SKELETON_SHAPES: E,
  SKELETON_TEXT_TYPES: s,
  SKELETON_HEADING_HEIGHTS: S
};
export {
  S as SKELETON_HEADING_HEIGHTS,
  T as SKELETON_RIPPLE_DURATION,
  E as SKELETON_SHAPES,
  _ as SKELETON_SHAPE_SIZES,
  s as SKELETON_TEXT_TYPES,
  c as default
};
//# sourceMappingURL=skeleton-constants.js.map
